import { render, staticRenderFns } from "./customArticle.vue?vue&type=template&id=0e84bee5&scoped=true"
import script from "./customArticle.vue?vue&type=script&lang=js"
export * from "./customArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84bee5",
  null
  
)

export default component.exports